<template>
	<div class="balenaLogs-page">
		<button @click="sortLogs(-1)">
			<img v-if="ascendant==1" src="./img/down.png" alt="down" width="15em" height="15em">
			<img v-else src="./img/up.png" alt="up" width="15em" height="15em">
		</button>
		<button @click="refresh">
			<img src="./img/refresh.png" alt="refresh" width="15em" height="15em">
		</button>
		<button @click="navigate">
			go back
		</button>
		<div v-for="(item, idx) in this.balenaLogs" v-bind:key="item.id" :class="{ 'grey-bg': item.id%2==0 }">
            {{idx}}
			<span class="timestamp">
				{{ printDate(item.timestamp) }}
			</span>
			: 
			<span>
				{{ item.message }}
			</span>
		</div>
		<div v-if="this.balenaLogs.length == 0">
			No log found for this device
		</div>
	</div>
</template>


<script>
    import router from '../router'
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { balenaLogs } from './../api'
    import config from './../config/config'

    export default {
        name: 'BalenaLogs',
        data () {
            return {
	            balenaLogs: [],
	            ascendant: -1,
				timer: '',
				deviceId: '',
            }
        },
        methods: {
            navigate() {
                router.go(-1);
            },
			...mapMutations([
			]),
		    ...mapActions([
		    ]),
		    async sortLogs(changeSens=1) { // sens = 1 -> Keep like it is, sens -1 -> Reverse
		    	var sens = this.ascendant*changeSens;
		    	await this.balenaLogs.sort(function(a,b) { return sens*(new Date(a.id).getTime()-new Date(b.id).getTime()) });
		    	this.ascendant = sens;
		    },
		    async refresh() {
		    	let res = await balenaLogs(this.deviceId);
                console.log('git logs ', res);
		    	if(res.success) {
		    		this.balenaLogs = res.data;
		    		this.$message.info("success refresh");
		    	}
		    	else {
		    		this.$message.error("An error has occurred");
		    	}
		    	this.sortLogs()
		    },
            printDate(dateStr, time = true) {
                let date = new Date(dateStr);
                return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}` + (time ? ` - ${this.leadingZero(date.getHours())}:${this.leadingZero(date.getMinutes())}:${this.leadingZero(date.getSeconds())}` : '');
            },
            leadingZero(num) {
                var s = num+"";
                while (s.length < 2) s = "0" + s;
                return s;
            }
        },
		computed: {
			...mapGetters([
			])
		},
        created() {
			if (this.$route.params.deviceID) {
				this.deviceId = this.$route.params.deviceID;
				this.$cookie.delete("deviceID");
				this.$cookie.set("deviceID", this.$route.params.deviceID, {expires: "8h"});
			}
			else {
				this.deviceId = this.$cookie.get("deviceID");
			}
        	this.refresh();
        	// Refresh every xx sec
	        this.timer = setInterval(this.refresh, config.refreshInterval);
		},
		beforeDestroy() {
		  	clearInterval(this.timer);
		}
    }
</script>


<style scoped>
	.balenaLogs-page {
		text-align: left;
	}
	.timestamp {
		color: blue;
	}
	.grey-bg {
		background-color: rgb(235,235,235);/*gainsboro;*/
	}
</style>


// WEBPACK FOOTER //
// src/components/BalenaLogs.vue